import { datadogLogs } from '@datadog/browser-logs';

import { isLocalhost } from '#utils/isLocalhost.ts';

import { config } from '../../config.ts';
import { cleanLogs } from './logging.ts';

if (!isLocalhost()) {
    datadogLogs.init({
        clientToken: config.dataDogClientToken,
        forwardErrorsToLogs: true,
        site: 'datadoghq.eu',
        sessionSampleRate: 100,
        version: '0.6.0',
        service: 'ordercom-cloud-frontend',
        env: 'prod',
        beforeSend: obj => cleanLogs(obj),
    });

    datadogLogs.setGlobalContextProperty('team_identifier', import.meta.env.VITE_TEAM_IDENTIFIER);
    datadogLogs.setGlobalContextProperty('account_id', import.meta.env.VITE_ACCOUNT_ID);
    datadogLogs.setGlobalContextProperty('account_name', import.meta.env.VITE_ACCOUNT_NAME);
}
